function modal_open(modal){
    $('body').addClass('stop-scrolling').addClass('modal-open');
    modal.fadeIn();
    modal.children('.modal-dialog').addClass('open');
}
function modal_close(){
    $('body').removeClass('stop-scrolling').removeClass('modal-open');
    $('.modal').fadeOut();
    $('.modal-dialog').removeClass('open');

    setTimeout(function() {
        let modal_draggable = $('.modal-draggable');
        if(modal_draggable.length){
            $('.modal-dialog', modal_draggable).css({
                transition: '',
                left: '',
                top: '',
                transform: ''
            });
        }
    }, 500);
}

$(document).ready(function(){

    /* modal open */
    $(document).on('click', '.js-modal' , function(){
        modal_open($($(this).attr('data-modal')));
    })
    $(document).on('click', '.js-modal-close' , function(){
        modal_close();
    })

    $(document).on('keyup',function(e) {
        if (e.key === 'Escape'){  // esc
            if( $('body').hasClass('modal-open') ){
                modal_close();
            }
            if($('.cookie-bar:visible')){
                $('.js-cookie-save').click();
            }
        }
    });

    /* drag&drop modal with class .modal-draggable */
    var modal_draggable = $('.modal-draggable');
    if(modal_draggable.length){

        var isDragging = false;
        var dragStartX, dragStartY, dialogStartX, dialogStartY;

        $('.modal-header', modal_draggable).on('mousedown', function(e) {
            isDragging = true;
            let modal_dialog = $('.modal-dialog', modal_draggable);
            $(this).addClass('dragged');

            dragStartX = e.clientX;
            dragStartY = e.clientY;
            dialogStartX = modal_dialog.offset().left;
            dialogStartY = modal_dialog.position().top;
        });

        $('.modal-header', modal_draggable).on('mouseup', function() {
            isDragging = false;
            $(this).removeClass('dragged');
        });

        $(document).on('mousemove', function(e) {

            if (isDragging) {

                let window_width = $( window ).width();
                if(window_width < 992){
                    return;
                }

                let modal_dialog = $('.modal-dialog', modal_draggable);

                modal_dialog.css({
                    transition: 'none'
                });

                let moveX = e.clientX - dragStartX;
                let moveY = e.clientY - dragStartY;

                let newLeft = dialogStartX + moveX;
                let newTop = dialogStartY + moveY;

                let modal_wrapper = $('.modal-dialog.open');

                let maxLeft = window_width - (modal_wrapper.width());
                let maxTop = $( window ).height() - modal_wrapper.height();

                newLeft = Math.max(0, Math.min(newLeft, maxLeft));
                newTop = Math.max(0, Math.min(newTop, maxTop));

                modal_dialog.css({
                    left: newLeft + 'px',
                    top: newTop + 'px',
                    transform: 'none'
                });
            }
        });

        $(window).resize(function(){
            $('.modal-draggable .modal-dialog.open').css({
                transition: '0.3s transform, 0.2s left, 0.2s top',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)'
            });
        });
    }
});
